import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      if (u.must_change_password) nav("/change-password");
      else nav(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || "Sign in failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md glass rounded-2xl p-8">
        <div className="flex justify-center mb-6"><Logo className="h-12" showText /></div>
        <h1 className="font-display text-2xl font-bold text-white text-center">Sign in</h1>
        <p className="text-sm text-slate-400 text-center mt-1">Access your Certalyth Academy account.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-slate-300">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input"
              className="bg-surface-2 border-white/10 text-white mt-1" />
          </div>
          <div>
            <div className="flex justify-between items-center">
              <Label className="text-slate-300">Password</Label>
              <Link to="/forgot-password" className="text-xs text-gold hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
            </div>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input"
              className="bg-surface-2 border-white/10 text-white mt-1" />
          </div>
          {error && <p className="text-sm text-rose-400" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full btn-gold h-11" disabled={loading} data-testid="login-submit-button">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Sign in
          </Button>
        </form>
        <p className="text-sm text-slate-400 text-center mt-6">
          Don't have an account? <Link to="/register" className="text-gold hover:underline">Sign up</Link>
        </p>
      </div>
    </div>
  );
}
